// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2nDef","title":"FrontImage_title__URMDn"};